import { useState } from 'react';
import { Button, Card, Chip, Typography } from '@equinor/eds-core-react';
import * as Styled from './ModelAreaCoordinates.styled';
import { useIsOwnerOrAdmin } from '../../../hooks/useIsOwnerOrAdmin';
import { analogueModelDefault } from '../../../constants/analogueModelDefault';
import { useFetchModel } from '../../../hooks/useFetchModel';
import * as StyledCard from '../../../styles/Card/Card.styled';
import { ModelAreasDialog } from './ModelAreasDialog/ModelAreasDialog';

export const ModelAreaCoordinates = () => {
  const { data: analogueModel = analogueModelDefault } = useFetchModel();
  const isOwnerOrAdmin = useIsOwnerOrAdmin();
  const [open, setOpen] = useState(false);

  const chips = ['Whole model']
    .concat(analogueModel.modelAreas.map((x) => x.modelAreaType))
    .map((e, i) => <Chip key={i}>{e}</Chip>);

  return (
    <>
      <Card className="card-areas">
        <Card.Header>
          <Typography variant="h4" as="h3" className="card-title">
            Model areas
          </Typography>
        </Card.Header>
        <StyledCard.Content>
          <Typography variant="body_long">
            You can define multiple areas for calculation in your model by
            entering coordinates. The current areas are listed below:
          </Typography>
          <Styled.ChipWrapper>{chips}</Styled.ChipWrapper>
          {isOwnerOrAdmin && (
            <Button variant="outlined" onClick={() => setOpen(true)}>
              Set model areas…
            </Button>
          )}
        </StyledCard.Content>
      </Card>

      <ModelAreasDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
